import { ContestTemplateModule } from '@/modules/fantasy/contest-template';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  q: z.string().optional(),
  sportType: z.string().optional(),
  contestType: z.string().optional(),
  entryFee: z.string().optional(),
  prizePool: z.string().optional(),
});

export const Route = createFileRoute('/dashboard/fantasy/contest-template/')({
  validateSearch: searchSchema,
  component: ContestTemplatePage,
});

function ContestTemplatePage() {
  return <ContestTemplateModule />;
}
